const axios = require('axios');

const BASE_URL = "";

const get = async function(url) {
	try {
		const response = await axios.get(BASE_URL + url);
		return response.data
	} catch (error) {
		console.error(error);
	}
}
const put = async function(url, params) {
	try {
		const response = await axios.put(BASE_URL + url, params);
		return response.data
	} catch (error) {
		console.error(error);
	}
}
const post = async function(url, params) {
	try {
		const response = await axios.post(BASE_URL + url, params);
		return response.data
	} catch (error) {
		console.error(error);
		// Prefer API error body when present (e.g. 404 password reset for unknown email)
		if (error.response && error.response.data) {
			return error.response.data;
		}
		throw error;
	}
}
const del = async function(url, params) {
	try {
		const response = await axios.delete(BASE_URL + url, { data: params });
		return response.data
	} catch (error) {
		console.error(error);
	}
}

const Api = {
	bootstrap: {
		get: () => (get('/api/bootstrap')),
	},
	users: {
		signin: (credentials) => (post('/api/users/signin', credentials)),
		signout: () => (get('/api/users/signout')),
		profile: {
			current: () => (get('/api/users/profile/current')),
		},
		sendDashUserPasswordUrl: (email) => (post('/api/users/send-dashboard-password-url', {email: email})),
	},
}

export default Api